var Nav = (function($) {

  var _s = {
    primary_nav: $('.primary-nav-container'),
    primary_nav_item: '.primary-nav-container #menu-primary-nav .menu-item',
    mobile_nav_trigger: '.mobile-nav-trigger',
    mobile_nav: '.mobile-nav',
    menu: '.menu',
    menu_item: '.menu-item',
    sub_menu: '.sub-menu',
  };

  var _init = function() {
    _bindEvents();
  };

  var _bindEvents = function() {

    // Hover Menu Item
    $(_s.primary_nav_item).on('mouseover focusin', function() {
      let $this = $(this);
      
      $this.addClass('active');
      $this.find(_s.sub_menu).stop().slideDown(200);
    });

    // Exit Menu Item
    $(_s.primary_nav_item).on('mouseleave focusout', function(e) {
      let $this = $(this);

      if ( ! $(e.relatedTarget).hasClass('sub-menu') ) {
        $this.removeClass('active');
        $this.find(_s.sub_menu).slideUp(200);
      }
    });

    // Exit Sub Menu
    $(_s.primary_nav_item).find(_s.sub_menu).on('mouseleave', function(e) {
      let $this = $(this);

      if ( ! $(e.relatedTarget).hasClass('menu-item') ) {
        $this.closest(_s.primary_nav_item).removeClass('active');
        $this.slideUp(200);
      }
    });

    
    // =================
    // Mobile Nav
    $(_s.mobile_nav_trigger).on('click', function() {
      $('body').toggleClass('mobile-nav-active');
    });
    
    // Expand Sub Menus
    $(_s.mobile_nav).find(_s.menu + ' ' + _s.menu_item+' > a').on('click', function() {
      let $this = $(this);
      let $menuItem = $this.closest(_s.menu_item);
      
      $menuItem.toggleClass('active');
      $menuItem.siblings().removeClass('active');
      $menuItem.siblings().find(_s.sub_menu).slideUp(200);
      $menuItem.find(_s.sub_menu).slideToggle(200);
    });
    

    // =================
    // Reset Nav items if window is resized
    $(window).on('resize', function() {
      $('body').removeClass('mobile-nav-active');

      $(_s.primary_nav_item).removeClass('active');
      $(_s.primary_nav_item).find(_s.sub_menu).slideUp(200);

      $(_s.mobile_nav).find(_s.menu_item).removeClass('active');
      $(_s.mobile_nav).find(_s.sub_menu).slideUp(200);
    });
  };



  return {
    init: _init
  };

})(jQuery);